<template>
  <div class="app-comment-body">
    <ul>
      <li v-for="item in commentList" :key="item.id">
        <!-- 存在二级评论 -->
        <div v-if="item.length !== 1">
          <ul>
            <li v-for="itemSec in item" :key="itemSec.id">
              <div></div>
            </li>
          </ul>
        </div>
        <!-- 只有一级评论 -->
        <div v-else></div>
      </li>
    </ul>
    <!-- 其他信息 -->
    <p class="app-comment-other">以上留言仅代表用户个人观点</p>
  </div>
</template>

<script>
export default {
  name: "Comment",
  data() {
    return {
      commentList: [
        [
          {
            infoText: ""
          },
          {
            infoText: ""
          }
        ],
        {
          infoText: ""
        }
      ]
    }
  }
}
</script>

<style scoped>

.app-comment-body {
  min-height: 1015px;
}

.app-comment-other {
  position: absolute;
  border-top: 1px solid rgba(20, 20, 20, 0.2);
  padding-top: 10px;
  bottom: 10px;
  right: 10px;
  left: 10px;
  text-align: right;
  color: rgba(20, 20, 20, 0.5);
}

</style>